(function () {
  'use strict';

  var containerSelector = '.product-form--main[data-stocking-status]';
  var purchaseComponentSelector = '[data-stocking-purchase-component]';
  var actionsSelector = '[data-stocking-actions]';
  var panelSelector = '[data-stocking-panel]';
  var forcedDisabledAttribute = 'data-stocking-forced-disabled';
  var observerScheduled = false;

  function normalizeStatus(value) {
    var status = String(value || '').trim();

    if (
      status !== 'Regular Stock' &&
      status !== 'Available by Request' &&
      status !== 'Sell Through' &&
      status !== 'Discontinued'
    ) {
      return 'Regular Stock';
    }

    return status;
  }

  function findVariantOption(container, variantId) {
    var options = container.querySelectorAll(
      'select[name="id"] option'
    );

    if (variantId) {
      for (var index = 0; index < options.length; index += 1) {
        if (String(options[index].value) === String(variantId)) {
          return options[index];
        }
      }
    }

    var selectedOption = container.querySelector(
      'select[name="id"] option:checked'
    );

    if (selectedOption) {
      return selectedOption;
    }

    return null;
  }

  function getSelectedVariantId(container) {
    var variantInput = container.querySelector(
      '.product-purchase-form [name="id"], select[name="id"], input[name="id"]'
    );

    return variantInput ? variantInput.value : '';
  }

  function getStockState(option) {
    if (!option) {
      return 'untracked';
    }

    var stockState = option.getAttribute('data-actual-stock-state');

    if (
      stockState !== 'in' &&
      stockState !== 'out' &&
      stockState !== 'untracked'
    ) {
      return 'untracked';
    }

    return stockState;
  }

  function calculateState(status, stockState) {
    if (status === 'Discontinued') {
      return {
        state: 'no-longer-available',
        purchaseAllowed: false
      };
    }

    if (stockState === 'out') {
      if (status === 'Available by Request') {
        return {
          state: 'available-by-request',
          purchaseAllowed: false
        };
      }

      if (status === 'Sell Through') {
        return {
          state: 'no-longer-available',
          purchaseAllowed: false
        };
      }

      return {
        state: 'regular-out-of-stock',
        purchaseAllowed: false
      };
    }

    return {
      state: 'purchasable',
      purchaseAllowed: true
    };
  }

  function setElementVisibility(element, visible) {
    if (!element) {
      return;
    }

    if (visible) {
      element.hidden = false;
      element.removeAttribute('inert');
      element.removeAttribute('aria-hidden');
    } else {
      element.hidden = true;
      element.setAttribute('inert', '');
      element.setAttribute('aria-hidden', 'true');
    }
  }

  function disablePurchaseControls(component) {
    var controls = component.querySelectorAll(
      'button, input[type="submit"], input[type="button"]'
    );

    controls.forEach(function (control) {
      if (!control.disabled) {
        control.disabled = true;
        control.setAttribute(forcedDisabledAttribute, 'true');
      }
    });
  }

  function restorePurchaseControls(component) {
    var controls = component.querySelectorAll(
      '[' + forcedDisabledAttribute + '="true"]'
    );

    controls.forEach(function (control) {
      control.disabled = false;
      control.removeAttribute(forcedDisabledAttribute);
    });
  }

  function updateActionMetadata(actions, option, variantId) {
    if (!actions) {
      return;
    }

    var sku = option
      ? option.getAttribute('data-variant-sku') || ''
      : '';

    actions.setAttribute('data-variant-id', variantId || '');
    actions.setAttribute('data-variant-sku', sku);

    var triggers = actions.querySelectorAll(
      '[data-stocking-inquiry-trigger], ' +
      '[data-stocking-contact-trigger], ' +
      '[data-stocking-notify-trigger]'
    );

    triggers.forEach(function (trigger) {
      trigger.setAttribute('data-variant-id', variantId || '');
      trigger.setAttribute('data-variant-sku', sku);
    });
  }

  function updatePanels(actions, state, purchaseAllowed) {
    if (!actions) {
      return;
    }

    actions.setAttribute('data-active-stocking-state', state);
    setElementVisibility(actions, !purchaseAllowed);

    var panels = actions.querySelectorAll(panelSelector);

    panels.forEach(function (panel) {
      var panelState = panel.getAttribute('data-stocking-panel');
      setElementVisibility(
        panel,
        !purchaseAllowed && panelState === state
      );
    });
  }

  function updatePurchaseComponents(container, purchaseAllowed) {
    var components = container.querySelectorAll(
      purchaseComponentSelector
    );

    components.forEach(function (component) {
      setElementVisibility(component, purchaseAllowed);

      if (purchaseAllowed) {
        restorePurchaseControls(component);
      } else {
        disablePurchaseControls(component);
      }
    });
  }

  function syncContainer(container, requestedVariantId) {
    if (!container) {
      return;
    }

    var status = normalizeStatus(
      container.getAttribute('data-stocking-status')
    );

    var variantId =
      requestedVariantId || getSelectedVariantId(container);

    var option = findVariantOption(container, variantId);
    var stockState = getStockState(option);
    var result = calculateState(status, stockState);
    var actions = container.querySelector(actionsSelector);

    container.setAttribute('data-stocking-status', status);
    container.setAttribute('data-stocking-state', result.state);
    container.setAttribute(
      'data-stocking-purchase-allowed',
      result.purchaseAllowed ? 'true' : 'false'
    );
    container.setAttribute(
      'data-stocking-stock-state',
      stockState
    );

    updatePurchaseComponents(
      container,
      result.purchaseAllowed
    );

    updatePanels(
      actions,
      result.state,
      result.purchaseAllowed
    );

    updateActionMetadata(
      actions,
      option,
      variantId
    );

    document.dispatchEvent(
      new CustomEvent('stocking-status:updated', {
        detail: {
          container: container,
          productId:
            container.getAttribute('data-product-id') || '',
          variantId: variantId || '',
          sku: option
            ? option.getAttribute('data-variant-sku') || ''
            : '',
          stockingStatus: status,
          stockingState: result.state,
          stockState: stockState,
          purchaseAllowed: result.purchaseAllowed
        }
      })
    );
  }

  function syncAllContainers() {
    document.querySelectorAll(containerSelector).forEach(
      function (container) {
        syncContainer(container);
      }
    );
  }

  function findContainerForProduct(productId) {
    var containers = document.querySelectorAll(
      containerSelector
    );

    var matches = [];

    containers.forEach(function (container) {
      if (
        String(container.getAttribute('data-product-id')) ===
        String(productId)
      ) {
        matches.push(container);
      }
    });

    return matches;
  }

  function isPurchaseBlocked(container) {
    return (
      container &&
      container.getAttribute(
        'data-stocking-purchase-allowed'
      ) !== 'true'
    );
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest(
        'form.product-purchase-form, ' +
        'form.mini-product-purchase-form'
      );

      if (!form) {
        return;
      }

      var container = form.closest(containerSelector);

      if (!isPurchaseBlocked(container)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var purchaseControl = event.target.closest(
        purchaseComponentSelector +
        ' button, ' +
        purchaseComponentSelector +
        ' input[type="submit"], ' +
        purchaseComponentSelector +
        ' input[type="button"]'
      );

      if (!purchaseControl) {
        return;
      }

      var container = purchaseControl.closest(
        containerSelector
      );

      if (!isPurchaseBlocked(container)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (
        !event.target.matches(
          containerSelector + ' [name="id"]'
        )
      ) {
        return;
      }

      var container = event.target.closest(
        containerSelector
      );

      window.setTimeout(function () {
        syncContainer(container, event.target.value);
      }, 0);
    },
    true
  );

  function attachThemeVariantListener() {
    if (!window.jQuery) {
      return;
    }

    window.jQuery(window)
      .off('cc-variant-updated.stockingStatus')
      .on(
        'cc-variant-updated.stockingStatus',
        function (event, args) {
          if (!args || !args.product) {
            return;
          }

          var containers = findContainerForProduct(
            args.product.id
          );

          containers.forEach(function (container) {
            syncContainer(
              container,
              args.variant ? args.variant.id : ''
            );
          });
        }
      );
  }

    function findKlaviyoBisButton(slot) {
    if (!slot) {
      return null;
    }

    var marker = slot.querySelector(
      '[data-stocking-notify-trigger]'
    );

    var placeholder = slot.querySelector(
      '[data-stocking-notify-placeholder]'
    );

    var candidates = slot.querySelectorAll(
      'button, a[href], [role="button"]'
    );

    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];

      if (
        candidate === marker ||
        candidate === placeholder
      ) {
        continue;
      }

      var buttonText = (
        candidate.textContent || ''
      )
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (buttonText.indexOf('notify me') !== -1) {
        return candidate;
      }
    }

    return null;
  }

  function initializeKlaviyoBisHandoff(root) {
    if (!window.MutationObserver) {
      return;
    }

    var scope = root || document;

    var slots = scope.querySelectorAll(
      '[data-stocking-notify-slot]:not([data-klaviyo-bis-handoff-initialized])'
    );

    slots.forEach(function (slot) {
      slot.setAttribute(
        'data-klaviyo-bis-handoff-initialized',
        'true'
      );

      var placeholder = slot.querySelector(
        '[data-stocking-notify-placeholder]'
      );

      var observer = null;

      function completeHandoff() {
        var klaviyoButton =
          findKlaviyoBisButton(slot);

        if (!klaviyoButton) {
          return false;
        }

        klaviyoButton.classList.add(
          'stocking-status-actions__klaviyo-button'
        );

        slot.setAttribute(
          'data-klaviyo-bis-ready',
          'true'
        );

        if (placeholder) {
          placeholder.hidden = true;
          placeholder.setAttribute(
            'aria-hidden',
            'true'
          );
        }

        if (observer) {
          observer.disconnect();
        }

        return true;
      }

      if (completeHandoff()) {
        return;
      }

      observer = new MutationObserver(
        function (mutations) {
          var hasAddedNodes = mutations.some(
            function (mutation) {
              return mutation.addedNodes.length > 0;
            }
          );

          if (hasAddedNodes) {
            completeHandoff();
          }
        }
      );

      observer.observe(slot, {
        childList: true,
        subtree: true
      });
    });
  }

  function scheduleObserverSync() {
    if (observerScheduled) {
      return;
    }

    observerScheduled = true;

    window.setTimeout(function () {
      observerScheduled = false;
      syncAllContainers();
    }, 50);
  }

  function observeDelayedAppContent() {
    if (!document.body || !window.MutationObserver) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0;
      });

      if (shouldSync) {
        scheduleObserverSync();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initialize() {
    attachThemeVariantListener();
    syncAllContainers();
    initializeKlaviyoBisHandoff(document);
    observeDelayedAppContent();

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        syncAllContainers();

        initializeKlaviyoBisHandoff(
          event.target || document
        );
      }
    );

    window.addEventListener(
      'pageshow',
      function () {
        syncAllContainers();
        initializeKlaviyoBisHandoff(document);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }
})();